import { useContext } from 'react';
import { ToastContext } from './ToastContext.js';

const useToast = () => {
    const { showToast, dismissToast } = useContext(ToastContext);
    return {
        showToast,
        dismissToast,
    };
};

export { useToast };
